// WalkthroughTooltip.js - Custom tooltip component for walkthrough with proper styling
import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { useCopilot } from 'react-native-copilot';
import { useTranslation } from '../i18n/useTranslation';

const WalkthroughTooltip = () => {
  const { currentStep, goToNext, goToPrev, stop, isFirstStep, isLastStep } = useCopilot();
  const { t } = useTranslation();

  if (!currentStep) return null;

  return (
    <View style={styles.container}>
      {/* Tooltip text — steps register English text, which doubles as the translation key */}
      <Text style={styles.text}>{t(currentStep.text)}</Text>

      {/* Button row */}
      <View style={styles.buttonRow}>
        {/* Skip button - left side */}
        <TouchableOpacity onPress={stop} style={styles.skipButton}>
          <Text style={styles.skipText}>{t('Skip')}</Text>
        </TouchableOpacity>

        {/* Spacer */}
        <View style={styles.spacer} />

        {/* Navigation buttons - right side */}
        <View style={styles.navButtons}>
          {!isFirstStep && (
            <TouchableOpacity onPress={goToPrev} style={styles.secondaryButton}>
              <Text style={styles.secondaryButtonText}>{t('Back')}</Text>
            </TouchableOpacity>
          )}
          <TouchableOpacity
            onPress={isLastStep ? stop : goToNext}
            style={styles.primaryButton}
          >
            <Text style={styles.primaryButtonText}>
              {isLastStep ? t('Finish') : t('Next')}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#6366f1',
    borderRadius: 16,
    paddingTop: 20,
    paddingBottom: 18,
    paddingHorizontal: 22,
    minWidth: 300,
    maxWidth: 360,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 0.3,
    shadowRadius: 16,
    elevation: 10,
  },
  text: {
    color: '#ffffff',
    fontSize: 15,
    lineHeight: 24,
    marginBottom: 20,
    fontWeight: '400',
  },
  buttonRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  skipButton: {
    paddingVertical: 10,
    paddingHorizontal: 4,
  },
  skipText: {
    color: 'rgba(255, 255, 255, 0.6)',
    fontSize: 14,
    fontWeight: '500',
  },
  spacer: {
    flex: 1,
  },
  navButtons: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  secondaryButton: {
    paddingVertical: 10,
    paddingHorizontal: 18,
    borderRadius: 10,
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.3)',
  },
  secondaryButtonText: {
    color: '#ffffff',
    fontSize: 14,
    fontWeight: '600',
  },
  primaryButton: {
    paddingVertical: 10,
    paddingHorizontal: 22,
    borderRadius: 10,
    backgroundColor: '#ffffff',
  },
  primaryButtonText: {
    color: '#6366f1',
    fontSize: 14,
    fontWeight: '600',
  },
});

export default WalkthroughTooltip;
